/**
 * Extends `SlideInAbstract` to display an informational slide-in panel with a tabbed layout.
 * Accepts an optional tab index when opened to jump directly to a specific tab.
 */
if (!customElements.get('info-slidein') && typeof SlideInAbstract === 'function') {
  class ComponentInfoSlideIn extends SlideInAbstract {
    constructor() {
      super();
      this.utilTabs = this.querySelector('util-tabs')
    }
    show (tabId) {
      super.show()
      if (this.utilTabs && !isNaN(parseInt(tabId))) {
       setTimeout(() => this.utilTabs.openTab(tabId), 50)
      }
    }
  }
  customElements.define('info-slidein', ComponentInfoSlideIn);
}
